import { useTranslate } from '@festina-life/ui/hooks'
import { typographyStyles } from '@festina-life/ui/structure'

type Props = {
  isAmendment: boolean
}

export const ValueEntityIndicator = ({ isAmendment }: Props) => {
  const translate = useTranslate()
  const label = isAmendment
    ? translate('amendmentIndicator.label')
    : translate('createOperationLink.value')

  return (
    <div
      className={typographyStyles({
        size: 'sm',
        intensity: 'tertiary',
      })}
    >
      {label}
    </div>
  )
}
